import { axiosInstance } from "@/lib/axiosInstance";

export interface DesignationType {
  id: string;
  college_id: string;
  email: string;
  name: string;
  description: string;
  is_active: boolean;
  created_at: string;
}

export const fetchAllDesignations = async (): Promise<DesignationType[]> => {
  const res = await axiosInstance.get("/v1/designations", {
    params: { active_only: true },
  });
  const designations = res.data?.items || res.data || [];
  return designations.filter((d: DesignationType) => d.name.toLowerCase() ==="admin");
};

/** Same endpoint but returns ALL designations including placement_officer (used in Roles form) */
export const fetchAllDesignationsUnfiltered = async (): Promise<DesignationType[]> => {
  const res = await axiosInstance.get("/v1/designations", {
    params: { active_only: true },
  });
  return res.data?.data || res.data || [];
};
